// extracted by mini-css-extract-plugin
export var videoContainer = "_j1-0";
export var videoIframe = "_j1-3";
export var videoLink = "_j1-1";
export var videoOverlay = "_j1-4";
export var videoOverlayText = "_j1-5";
export var videoWrapper = "_j1-2";